import React from 'react';
import { Button } from '@/components/ui/button';

interface ServiceProfileContactActionsProps {
  whatsappNumber: string;
  whatsappLink: string;
  onClickWhatsApp: () => void;
}

export const ServiceProfileContactActions: React.FC<ServiceProfileContactActionsProps> = ({
  whatsappNumber,
  whatsappLink,
  onClickWhatsApp,
}) => {
  if (!whatsappNumber) return null;
  return (
    <div className="flex w-full flex-col gap-3 border-t border-brand-cloud pt-7 sm:flex-row sm:gap-4">
      {whatsappNumber && (
        <Button
          asChild
          className="w-full flex-1 rounded-md bg-whatsapp font-medium text-white hover:bg-whatsapp-hover"
        >
          <a
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            onClick={onClickWhatsApp}
          >
            Message on WhatsApp
          </a>
        </Button>
      )}
    </div>
  );
};
